<template>
  <Loader v-if="!display"></Loader>
  <div class="row" v-else>
    <div class="col-lg-12 col-xs-12">
      <b-card>
        <h6 class="card-title mt-0 mb-2">{{$t('views.exsbbankpackages.show.package')}}</h6>
        <b-card-body>
          <b-row class="mt-2">
            <b-col>
              <p class="p-0" v-if="data.item.description"><b>{{ $t('global.description') }}</b>: {{data.item.description}}</p>
              <p class="p-0" v-if="data.item.value"><b>{{ $t('views.exsbbankpackages.show.value') }}</b>: {{data.item.value}} {{$t('currency')}}</p>
            </b-col>
            <b-col>
              <p class="p-0" v-if="data.item.count"><b>{{ $t('views.exsbbankpackages.show.count') }}</b>: {{data.item.count}}</p>
            </b-col>
            <b-col>
              <p class="p-0" v-if="data.item.idBank"><b>{{ $t('views.exsbbankpackages.show.bankTitle') }}</b>: {{data.item.idBank.title}}</p>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
    <div class="col-lg-12 col-xs-12">
      <b-card>
        <h6 class="card-title mt-0">{{$t('views.exsbbankpackages.show.packagelistToDo')}}</h6>
        <b-card-body>
          <b-table
            id="paymentsLinkTable"
            striped hover
            :borderless="true"
            :total-rows="data.paymentsLink.length"
            :per-page="paymentsLinkPerPage"
            :current-page="data.paymentsLinkPage"
            :fields="paymentsLinkFields"
            :items="data.paymentsLink"
          >
            <template v-slot:cell(options)="data">
              <b-dropdown
                class="float-left"
                size="sm" variant="link"
                right text="Right align"
                toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fa fa-bars fa-lg"></i>
                </template>
                <b-dropdown-item @click="$router.push({name: 'EXSBPaymentsMadeUpdate', params: { id: data.item['@id'] }})"><i class="fa fa-eye mr-2"></i>{{$t('buttons.edit')}}</b-dropdown-item>
                <b-dropdown-item @click="autoAddToInvoice(data.item['@id'])"><i class="fa fa-file-signature"></i> {{$t('buttons.autoAddToInvoice')}}</b-dropdown-item>
                <b-dropdown-item @click="autoAddToAgreement(data.item['@id'])"><i class="fa fa-file-signature"></i> {{$t('buttons.autoAddToAgreement')}}</b-dropdown-item>
                <b-dropdown-item @click="deleteSingle(data.item.idBankPayment['@id'])"><i class="fa fa-trash"></i> {{$t('buttons.delete')}}</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="d-flex justify-content-between">
            <b-pagination
              v-model="data.paymentsLinkPage"
              :total-rows="data.paymentsLink.length"
              :per-page="paymentsLinkPerPage"
              aria-controls="paymentsLinkTable"
            ></b-pagination>
            <select id="dropdown-paymentsLinkTable" :text="$t('global.itemsPerPage')" class="m-md-2" v-model="paymentsLinkPerPage">
              <option v-for="option in [5, 10, 25, 50]" :key="option" :value="option">
                {{ option }}
              </option>
              <option :value="data.paymentsLink.length">{{ $t('menu.agreements.listAll') }}</option>
            </select>
          </div>
          <span v-if="data.paymentsLink.length">{{$t('global.totalItems')}}: {{data.paymentsLink.length}}</span>
        </b-card-body>
      </b-card>
      <b-card>
        <h6 class="card-title mt-0">{{$t('views.exsbbankpackages.show.packagelistDoneInvoices')}}</h6>
        <b-card-body>
          <b-table
            id="paymentsInvoicesTable"
            striped hover
            :borderless="true"
            :total-rows="data.paymentsInvoices.length"
            :per-page="paymentsInvoicesPerPage"
            :current-page="data.paymentsInvoicesPage"
            :fields="paymentsInvoicesFields"
            :items="data.paymentsInvoices"
          >
            <template v-slot:cell(invoice)="data">
              <router-link :to="{ name: 'EXSBInvoiceShow', params: { id: data.item.idEXSBInvoice['@id'] }}">
                {{ data.item.invoice }}
              </router-link>
            </template>
            <template v-slot:cell(options)="data">
              <b-dropdown
                class="float-left"
                size="sm" variant="link"
                right text="Right align"
                toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fa fa-bars fa-lg"></i>
                </template>
                <b-dropdown-item @click="$router.push({name: 'EXSBPaymentsMadeUpdate', params: { id: data.item['@id'] }})"><i class="fa fa-eye mr-2"></i>{{$t('buttons.edit')}}</b-dropdown-item>
                <b-dropdown-item @click="removeInvoiceFromPayments(data.item['@id'])"><i class="fa fa-trash"></i> {{$t('buttons.removeInvoiceFromPayments')}}</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="d-flex justify-content-between">
            <b-pagination
              v-model="data.paymentsInvoicesPage"
              :total-rows="data.paymentsInvoices.length"
              :per-page="paymentsInvoicesPerPage"
              aria-controls="paymentsInvoicesTable"
            ></b-pagination>
            <select id="dropdown-paymentsInvoicesTable" :text="$t('global.itemsPerPage')" class="m-md-2" v-model="paymentsInvoicesPerPage">
              <option v-for="option in [5, 10, 25, 50]" :key="option" :value="option">
                {{ option }}
              </option>
              <option :value="data.paymentsInvoices.length">{{ $t('menu.agreements.listAll') }}</option>
            </select>
          </div>
          <span v-if="data.paymentsInvoices.length">{{$t('global.totalItems')}}: {{data.paymentsInvoices.length}}</span>
        </b-card-body>
      </b-card>
      <b-card>
        <div class="card-header">
          <h6 class="card-title mt-0 mb-4">{{$t('views.exsbbankpackages.show.packagelistDone')}}</h6>
        </div>
        <b-card-body>
          <table class="table table-sm table-striped table-hover">
            <thead>
            <tr>
              <th>{{$t('tableHeadings.operationType')}}</th>
              <th>{{$t('tableHeadings.payer')}}</th>
              <th>{{$t('views.excmconsent.show.description')}}</th>
              <th>{{$t('tableHeadings.agreement')}}</th>
              <th>{{$t('tableHeadings.valueSingle')}}</th>
              <th>{{$t('views.excmtag.options')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in data.paymentsUnlink" :key="item.id">
              <td>{{ item.operationType }}</td>
              <td>{{ item.payer }}</td>
              <td>{{ item.description }}</td>
              <td>
                <router-link :to="{ name: 'EXABAgreementShow', params: { id: item.idAgreement['@id'] } }">
                  {{ item.agreement }}
                </router-link>
              </td>
              <td>{{ item.value }}</td>
              <td>
                <b-dropdown
                  class="float-left"
                  size="sm" variant="link"
                  right text="Right align"
                  toggle-class="text-decoration-none" no-caret>
                  <template #button-content>
                    <i class="fa fa-bars fa-lg"></i>
                  </template>
                  <b-dropdown-item @click="$router.push({name: 'EXSBPaymentsMadeUpdate', params: { id: item['@id'] }})"><i class="fa fa-eye mr-2"></i>{{$t('buttons.edit')}}</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
            </tbody>
          </table>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import VueForm from 'vue-form'
import Loader from '@/components/Dashboard/Layout/Loader'
import ApiService from '@/utils/ApiService'
import remove from '@/utils/remove'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'BankPackagesShow',
  mixins: [VueForm],
  components: {
    Loader
  },
  data () {
    return {
      display: false,
      paymentsLinkPerPage: 10,
      paymentsUnlinkPerPage: 10,
      paymentsInvoicesPerPage: 10,
      data: {
        item: {},
        payments: {},
        paymentsUnlink: [],
        paymentsUnlinkPage: 1,
        paymentsLink: [],
        paymentsLinkPage: 1,
        paymentsInvoices: [],
        paymentsInvoicesPage: 1
      },
      formstate: {},
      loadingResults: {},
      downloadXlsStatus: 0,
      banksOptions: [],
      rowsdata: [],
      paymentsLinkFields: [
        { key: 'operationType', label: this.$t('tableHeadings.operationType') },
        { key: 'payer', label: this.$t('tableHeadings.payer') },
        { key: 'description', label: this.$t('views.excmconsent.show.description') },
        { key: 'value', label: this.$t('tableHeadings.valueSingle') },
        { key: 'options', label: this.$t('views.excmtag.options') }
      ],
      paymentsInvoicesFields: [
        { key: 'operationType', label: this.$t('tableHeadings.operationType') },
        { key: 'payer', label: this.$t('tableHeadings.payer') },
        { key: 'description', label: this.$t('views.excmconsent.show.description') },
        { key: 'invoice', label: this.$t('views.exsbpaymentsmade.list.invoice') },
        { key: 'value', label: this.$t('tableHeadings.valueSingle') },
        { key: 'options', label: this.$t('views.excmtag.options') }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.data = await new ApiService(decodeURIComponent(this.$route.params.id)).getResults()
      for (let i in this.data.payments) {
        this.data.payments[i].operationType = this.data.payments[i].idBankPayment.operationType
        this.data.payments[i].payer = this.data.payments[i].idBankPayment.payer
        this.data.payments[i].description = this.data.payments[i].idBankPayment.description
        if (this.data.payments[i].idAgreement !== null) {
          this.data.payments[i].agreement = this.data.payments[i].idAgreement.number
          if (this.data.payments[i].idAgreement.idClient !== null) {
            this.data.payments[i].agreement += ' ' + this.data.payments[i].idAgreement.idClient.fullName + ' ' + this.data.payments[i].idAgreement.idClient.firmname1
          }
        }
        if (this.data.payments[i].idEXSBInvoice !== null) {
          this.data.payments[i].invoice = this.data.payments[i].idEXSBInvoice.number
          if (this.data.payments[i].idEXSBInvoice.idUserData !== null) {
            this.data.payments[i].invoice += ' ' + this.data.payments[i].idEXSBInvoice.idUserData.fullName + ' ' + this.data.payments[i].idEXSBInvoice.idUserData.firmname1
          }
        }
        this.data.payments[i].value = this.data.payments[i].value + ' ' + this.$t('currency')
      }
      this.data.paymentsLink = this.data.payments.filter(item => item.idAgreement === null && item.idEXSBInvoice === null)
      this.data.paymentsUnlink = this.data.payments.filter(item => item.idAgreement !== null && item.idEXSBInvoice === null)
      this.data.paymentsInvoices = this.data.payments.filter(item => item.idEXSBInvoice !== null)
      this.display = true
    },
    clearData () {
      this.data.data = {
        idBank: undefined,
        description: '',
        bankFile: null
      }
    },
    async autoAddToAgreement (id) {
      const response = await new ApiService(`${id}/autoaddtoagreement`).put({})
      if (response.status === 200) {
        this.fetchData()
      }
    },
    async autoAddToInvoice (id) {
      const response = await new ApiService(`${id}/autoaddtoinvoice`).put({})
      if (response.status === 200) {
        this.fetchData()
      }
    },
    async removeInvoiceFromPayments (id) {
      const response = await new ApiService(`${id}/removeinvoicefrompayment`).put({})
      if (response.status === 200) {
        this.fetchData()
      }
    },
    deleteSingle (id) {
      let idBankPayment = getId(id)
      let link = 'e_x_s_b_bank_packages/deletesingle/' + idBankPayment
      remove(link, () => {
        this.fetchData()
      })
    },
    setPaymentsUnlinkPerPage (number) {
      this.data.paymentsUnlinkPerPage = number
    },
    setPaymentsLinkPerPage (number) {
      this.data.paymentsLinkPerPage = number
    },
    setPaymentsInvoicesPerPage (number) {
      this.data.paymentsInvoicesPerPage = number
    }
  }
}
</script>

<style scoped>

</style>
